import { cn } from '../../lib/cn';

export type TabKey = 'to_sign' | 'mes_envois';

interface Props {
  active: TabKey;
  onChange: (k: TabKey) => void;
  counts: Record<TabKey, number>;
}

const TABS: Array<{ key: TabKey; label: string }> = [
  { key: 'to_sign', label: 'À signer' },
  { key: 'mes_envois', label: 'Mes envois' },
];

export function ParapheurTabs({ active, onChange, counts }: Props) {
  return (
    <div className="border-b border-neutral-200 flex items-center gap-4">
      {TABS.map((t) => (
        <button
          key={t.key}
          onClick={() => onChange(t.key)}
          className={cn(
            'py-2 px-1 text-sm border-b-2 -mb-px transition',
            active === t.key
              ? 'border-cime-primary text-cime-primary font-medium'
              : 'border-transparent text-cime-text-muted hover:text-cime-text-primary',
          )}
        >
          {t.label}
          {counts[t.key] > 0 && (
            <span className="ml-1.5 inline-flex items-center justify-center min-w-5 h-5 px-1 rounded-full bg-neutral-100 text-[10px] font-medium text-neutral-700">
              {counts[t.key]}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
